import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import { vars } from '~/styles/theme.css'
import { invertColor } from '~/utils/color'
import { taskTypeIcon, taskTypeIconSmall } from './TaskTypeIcon.css'

type TaskTypeIconProps = {
  icon: IconDefinition
  /** Hex color of the custom action type; the default palette applies when null. */
  color?: string | null
  small?: boolean
  className?: string
}

const isHexColor = (color: string) => /^#[0-9A-Fa-f]{6}$/.test(color)

export const TaskTypeIcon = ({
  icon,
  color,
  small = false,
  className
}: TaskTypeIconProps): ReactElement => {
  const customColor = color && isHexColor(color) ? color : null

  return (
    <span
      className={clsx(taskTypeIcon, small && taskTypeIconSmall, className)}
      style={
        customColor
          ? {
              backgroundColor: customColor,
              color: invertColor(customColor, vars.color.dark, vars.color.white)
            }
          : undefined
      }
    >
      <FontAwesomeIcon icon={icon} />
    </span>
  )
}
